<script>
    import {PATH_PREFIX} from '../../apiUrls.js';
    export let branch = 'BHP';
    export let branchId = 1;
    export let execution = false;
    export let workCentreId = 0;

	import { checked, labelWithCount } from './HomePage.svelte';

    import {sgettext} from '../../i18n.js';

    import AllTimeConfirmations from './AllTimeConfirmations.svelte';
    import MainWorkCentreSelect from './MainWorkCentreSelect.svelte';
    import WorkOrder from './WorkOrder.svelte';
       
    import LeftRightBox from './LeftRightBox.svelte';
    import Tabs from '../Tabs/Tabs.svelte';
    import Tab from '../Tabs/Tab.svelte';
    import TabPanel from '../Tabs/TabPanel.svelte';
    import TabBar from '../Tabs/TabBar.svelte';
    import {buildUrl} from '../../utils';
    import {
        dashBoardWorkCentreId,
        dashboardWorkOrder
    } from './dashBoardStrore.js';
  import FailedTimeConfirmations from './FailedTimeConfirmations.svelte';
  import PendingTimeConfirmations from './PendingTimeConfirmations.svelte';


    let stats = {};
    const fetchCounts = async (params) => {
        stats = await (await fetch(buildUrl(`${PATH_PREFIX}/sw/api/time_confirmation_stats`, params))).json();
    }
    /**
     * 'work_centre' and 'work_order' are intentionally snake-cased to support old and new style 
     * task list configurations. See app/api/TimeConfirmationStatsView
    */
    $: fetchCounts({branch: branchId, checked: $checked, work_centre: $dashBoardWorkCentreId, work_order: $dashboardWorkOrder});

</script>

<Tabs className="subtabs" persistKey="homepage-time-confirmations">
  <LeftRightBox>
    <label slot="left">{sgettext('$$TIME_CONFIRMATIONS$$')}</label>
    <TabBar slot="right">
      <WorkOrder />
      <MainWorkCentreSelect {branchId} bind:value={workCentreId} />
      <Tab
        key="all"
        label={sgettext('$$ALL$$') + (stats.total != null ? ` (${stats.total})` : '')}
        component={AllTimeConfirmations}
        {branchId}
        {branch}
      />
      <Tab
        key="failed"
        label={sgettext('$$FAILED$$') + (stats.failed != null ? ` (${stats.failed})` : '')}
        component={FailedTimeConfirmations}
        {branchId}
        {branch}
      />
      <Tab
        key="pending"
        label={sgettext('$$PENDING$$') + (stats.pending != null ? ` (${stats.pending})` : '')}
        component={PendingTimeConfirmations}
        {branchId}
        {branch}
      />
    </TabBar>
  </LeftRightBox>
  <TabPanel />
</Tabs>
